if (process.env.REACT_APP_ENV === 'production') {
  module.exports = require('./configureStore.prod')
} else if (process.env.REACT_APP_ENV === 'development') {
  module.exports = require('./configureStore.local')
} else {
  module.exports = require('./configureStore.local')
}
